import { Component, Input, OnInit, Output } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { SharedService } from "@shared/services/shared.service";

import { BusinessService } from "app/services/business/business.service";
import { IBusinessView } from "app/models/business/business";
import { AuthService } from "@shared/auth/auth.service";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { ISelectItems } from "app/models/shared/shared";

import { Subscription } from "rxjs";


@Component({
  selector: 'help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})

export class HelpComponent implements OnInit {



  constructor(
    private sharedService: SharedService,
    private authService: AuthService,
    private complaintService: ComplaintService,
    private businessService: BusinessService,
    private modalService: MatDialog
  ) {

  }

  ngOnInit(): void {
    
    // this.sharedService.
  }

  ngOnDestroy() {

  }
}

import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class RedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

      window.location.href = route.data['externalUrl'];
      return true;

  }
}